<!--suppress ALL -->
<template>
  <transition :name="transitionName">
    <router-view></router-view>
  </transition>
</template>
<script>
import { addListener, removeListener } from '@/router-listener'

export default {
  name: 'App',
  mounted () {
    addListener(this.cancel)
  },
  data () {
    return {
      forward: true,
      stack: []
    }
  },
  computed: {
    transitionName () {
      return this.forward ? 'slide-left' : 'slide-right'
    }
  },
  methods: {
    cancel (to, from) {
      console.log('to: ', to.fullPath)
      console.log('from: ', from.fullPath)
      let seted = false
      let forward = false
      if (this.stack.length === 0) {
        forward = true
        this.stack.push(from.fullPath)
        this.stack.push(to.fullPath)
        seted = true
      }
      if (to.fullPath === this.stack[this.stack.length - 2]) {
        forward = false
      } else {
        forward = true
      }
      if (!seted) {
        if (forward) {
          this.stack.push(to.fullPath)
        } else {
          this.stack.pop()
        }
        seted = true
      }
      this.forward = forward
    }
  },
  destroyed () {
    removeListener(this.cancel)
  }
}
</script>
<style lang="less">
@import "common";

.slide-left-leave-active, .slide-right-leave-active {
  transition: all .5s;
}

.slide-left-enter-active, .slide-right-enter-active {
  transition: all .5s;
  position: absolute;
  top: 0;
}

.slide-left-leave {
  transform: translateX(0);
}

.slide-left-leave-to, .slide-right-enter {
  transform: translateX(-100%);
}

.slide-left-enter-to {
  transform: translateX(0);
}

.slide-left-enter, .slide-right-leave-to {
  transform: translateX(100%);
}

body {
  margin: 0;
  overflow-x: hidden;
}

.container {
  width: 100%;
  min-height: calc(100vh - 100px);

  .app {
    background: white;
  }

  // 打印模式隐藏滚动条
  @media print {
    &::-webkit-scrollbar {
      display: none;
    }

    & {
      -ms-overflow-style: none;
    }
  }

  @media screen {
    @media (min-width: 720px) {
      & {
        background: #efefef;
        padding: 50px 0;
      }

      .app {
        width: 720px;
        box-shadow: 10px 10px 36px #d6d6d6;
        border-radius: 4px;
        margin: 0 auto;
      }
    }
  }
}

</style>
